import { useState } from "react";
import { useNavigate } from "react-router";
import styles from "src/features/Event/components/CreateEventButton/createEventButton.module.css";
import SelectCreationEventTypeModal from "src/features/Event/components/SelectCreationEventTypeModal/SelectCreationEventTypeModal";
import localStorageManager from "src/utils/localStorageManager";

const CreateEventButton: React.FC = () => {
    const navigate = useNavigate();

    const certification = localStorageManager.getItem("certification");

    const [isModalOpen, setIsModalOpen] = useState(false);

    const onClick = () => {
        if (certification === "kobe_certified") {
            setIsModalOpen(true);
            return;
        }
        navigate("/event/create");
    };

    return (
        <>
            <div
                className={`${styles.container}`}
                onClick={onClick}
                onKeyDown={onClick}
                role="button"
                tabIndex={0}
                aria-label="イベントを作成する"
            >
                <div className={styles.plus_icon}>{}</div>
            </div>

            {certification === "kobe_certified" && (
                <SelectCreationEventTypeModal
                    isModalOpen={isModalOpen}
                    setModalOpen={setIsModalOpen}
                />
            )}
        </>
    );
};

export default CreateEventButton;
